<template>
  <div class="best-value-ribbon">
    <BestValueRibbonIcon class="best-value-ribbon__icon" />
    <span>BEST VALUE</span>
  </div>
</template>

<script>
import BestValueRibbonIcon from '@/assets/icons/plans/best_value_ribbon.svg'

export default {
  name: 'BestValueRibbon',
  components: {
    BestValueRibbonIcon,
  },
}
</script>

<style lang="scss" scoped>
.best-value-ribbon {
  width: 56px;
  display: flex;
  justify-content: center;
  position: relative;
  &__icon {
    z-index: -1;
  }
  span {
    position: absolute;
    text-align: center;
    top: 20px;
    font-family: var(--font-bold);
    font-size: 12px;
    color: var(--white);
  }
}
</style>
